import {getElement} from "./helpers.js";
import tabs from "./tabs.js";
export default function  loginPage (){
    if (!getElement('[data-page="login"]'))return

    tabs(
        '[data-tabs="login-section"]',
        ".tabs__nav",
        ".tabs__body",
        ".tabs__btn",
        "active",
        "show"
    );
    const resetPassword =  getElement('.reset-password');
    getElement('[data-reset-password]').addEventListener('click', () => {
        // resetPassword.classList.remove('hide')
       resetPassword.classList.add('show');
    })
    getElement('.reset-password__close').addEventListener('click', () => {
        resetPassword.classList.remove('show')
        // resetPassword.classList.add('hide');
    });

}